/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

/**
 * Partial update for a connection's ``sync_settings``.
 *
 * Extras are forbidden so an unknown key is a 422, not a silent no-op. Every
 * field is optional; only the ones provided are merged over the resolved
 * defaults (see ``connection_sync_settings``).
 */
export interface SyncSettingsPatch {
  auto_sync_on_add?: boolean | null;
  auto_enrich_on_auto_sync?: boolean | null;
  show_job_ids_in_picker?: boolean | null;
}
